export default [
  {
    title: 'Valid?',
    dataIndex: 'valid',
    slots: {
      customRender: 'tags',
    },
  },
  {
    title: 'Kode Program',
    dataIndex: 'program_code',
  },
  {
    title: 'Kode Toko',
    dataIndex: 'customer_code',
  },
  {
    title: 'Judul',
    dataIndex: 'judul',
  },
  {
    title: 'Brand',
    dataIndex: 'brand',
  },
  {
    title: 'Target Name',
    dataIndex: 'target_name',
  },
  {
    title: 'Target Value',
    dataIndex: 'target_value',
  },
  // {
  //   title: 'Target Q1',
  //   dataIndex: 'target_q1',
  // },
  // {
  //   title: 'Target Q2',
  //   dataIndex: 'target_q2',
  // },
  // {
  //   title: 'Target Q3',
  //   dataIndex: 'target_q3',
  // },
  // {
  //   title: 'Target Q4',
  //   dataIndex: 'target_q4',
  // },
  {
    title: 'Deskripsi',
    dataIndex: 'description',
  },
  {
    title: 'Start Date',
    dataIndex: 'start_date',
  },
  {
    title: 'End Date',
    dataIndex: 'end_date',
  },
  {
    title: 'Action',
    dataIndex: 'action',
  },
]
